<template>
  <v-dialog
    v-model="dialog"
    persistent
    :scrollable="scrollable"
    :width="width"
    :max-width="maxWidth ? maxWidth : '35vw'"
  >
    <v-card>
      <v-card-title class="justify-center white--text" :class="color">{{
        title
      }}</v-card-title>

      <v-divider></v-divider>

      <!-- scrollable モード: max-height を明示して overflow-y: auto を有効化 -->
      <v-card-text v-if="scrollable" style="overflow-y: auto; max-height: 65vh;">
        <slot></slot>
      </v-card-text>
      <slot v-else></slot>

      <v-card-actions class="justify-space-around pb-6">
        <slot name="footer"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    width: String,
    maxWidth: String,
    color: String,
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
